import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/8 bg-ink-950 px-5 py-12 sm:px-8" data-id="element-158" data-mp="32wd0e9mw79qd">
      <div className="mx-auto grid w-full max-w-4xl gap-6 text-center sm:text-left md:grid-cols-2" data-id="element-159" data-mp="3gg10u7y865zr">
        <div data-id="element-160" data-mp="32p5mig4yiwos">
          <p className="text-sm font-bold text-white" data-id="element-161" data-mp="32pfci3q053uh">Diccionario Apple™</p>
          <p className="mt-2 text-xs leading-relaxed text-white/45" data-id="element-162" data-mp="36qhg0wqyc229">
            La guía completa para usar tu iPhone como un profesional. Porque
            aprovechar tu celular no debería costarte horas de tutoriales
            sueltos.
          </p>
          <p className="mt-3 text-xs leading-relaxed text-white/45" data-id="element-163" data-mp="3lecb2jsfmiii">
            Un producto de{' '}
            <span className="font-semibold text-white/70" data-id="element-164" data-mp="3qdf2h1fhoq80">
              Celulares Nuevos Avedra
            </span>
            , una de las marcas de venta de productos Apple más grandes de
            Argentina.
          </p>
        </div>
        <div className="text-xs leading-relaxed text-white/40 md:text-right" data-id="element-165" data-mp="2ezb9nykn184j">
          <p data-id="element-166" data-mp="3l90n1twdyuy7">Marcio Gómez · Especialista en el ecosistema Apple</p>
          <p className="mt-2" data-id="element-167" data-mp="3lbdces4h47la">
            <a href="https://instagram.com/celularesnuevossaavedra" target="_blank" rel="noopener noreferrer" className="font-semibold text-white/60 transition-colors hover:text-white" data-id="element-168" data-mp="3gaz213feglk3">
              @celularesnuevossaavedra
            </a>{' '}
            · +180.000 seguidores
          </p>
          <p className="mt-2" data-id="element-169" data-mp="82ie9xijwigy">
            Asesor por WhatsApp:{' '}
            <a href="https://wa.me/5491124006361" target="_blank" rel="noopener noreferrer" className="font-semibold text-white/60 transition-colors hover:text-white" data-id="element-170" data-mp="80nrednpyga8">
              911 2400 6361
            </a>
          </p>
          <p className="mt-2" data-id="element-171" data-mp="cu0cwex3q6yr">atencionstockdigital@gmail.com</p>
          <p className="mt-2" data-id="element-172" data-mp="cvto87intfd3">
            Producto educativo independiente, no afiliado ni respaldado por
            Apple Inc.
          </p>
        </div>
      </div>

      <p className="mx-auto mt-8 w-full max-w-4xl border-t border-white/8 pt-6 text-center text-[11px] uppercase tracking-[0.18em] text-white/30" data-id="element-173" data-mp="mt7rf5fko7ng">
        © Diccionario Apple™ {new Date().getFullYear()} — Todos los derechos
        reservados.
      </p>
    </footer>;
}